

export default {
  namespaced: true,  // common
  state: {
  },
  actions: {},
  mutations: {
    // 设置state
    setState(state, [ key, data ]) { state[key] = data },
  }
}